
const _ = require('lodash');

const Notification = require('./notification.js');

const template = require('notifications/templates/passive-notification.html');


class PassiveNotification extends Notification {
	constructor (options) {
		options = _.defaultsDeep(options || {}, {
			css: {
				'notification-passive': true,
			},

			template: {
				html: template(),
				data: {
					message: options && options.message,
				},
			},
		});

		super(options);
	}
}

module.exports = PassiveNotification;

